// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChangesModal_wrapper_1XTXN"};